var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57514 3.21684L1.51681 15.0002C1.37128 15.2522 1.29428 15.5379 1.29346 15.8289C1.29265 16.12 1.36805 16.4061 1.51216 16.6589C1.65627 16.9118 1.86408 17.1225 2.1149 17.27C2.36571 17.4176 2.65081 17.497 2.94181 17.5002H17.0585C17.3495 17.497 17.6346 17.4176 17.8854 17.27C18.1362 17.1225 18.344 16.9118 18.4881 16.6589C18.6322 16.4061 18.7076 16.12 18.7068 15.8289C18.706 15.5379 18.629 15.2522 18.4835 15.0002L11.4251 3.21684C11.2766 2.97193 11.0674 2.76944 10.8178 2.62891C10.5682 2.48838 10.2866 2.41455 10.0001 2.41455C9.71369 2.41455 9.43208 2.48838 9.18248 2.62891C8.93287 2.76944 8.7237 2.97193 8.57514 3.21684V3.21684Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10.8333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1665H10.0083",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.17a703029d438bd950983c29df84b766.svg";